import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const HeaderWrapper = styled.header<IHeaderWrapperProps & IWithSize>`
  position: sticky;
  top: 0;
  height: ${({ size }) => (size ? 56 * size : 56)}px;
  transition: all 0.2s ease-in-out;
  transform: translateZ(0);
  z-index: 40;

  background-color: white;
  @media (min-width: ${(props: ITheme) => props.theme.breakpoints.tablet}) {
    background-color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    padding-left: ${({ size }) => (size ? 56 * size : 56)}px;
    ${is('isSidebarOpen')`
      padding-left: 240px;
    `}
  }
`

export default HeaderWrapper

export interface IHeaderWrapperProps {
  isSidebarOpen: boolean
}
